import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-grid-files',
  templateUrl: './grid-files.component.html',
  styleUrls: ['./grid-files.component.css']
})
export class GridFilesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
